<script lang="ts">
  import type { WorkoutPanelProps } from '$lib/types/articleTypes';
  import ExercisePanel from './ExercisePanel.svelte';
  import RestPanel from './RestPanel.svelte';
  export let workoutName: WorkoutPanelProps['workoutName'];
  export let workoutSummary: WorkoutPanelProps['workoutSummary'];
  export let exercisesAndRestsCollection: WorkoutPanelProps['exercisesAndRestsCollection'];
</script>

<section class="flex flex-col">
  <div class="flex flex-row justify-between pb-5 px-4 lg:px-0">
    {#if workoutName !== null}
      <h2 class="text-gray-900 text-xxl sm:text-[1.875rem] font-semibold pb:1 md:pb-4 break-words">
        {workoutName}
      </h2>
    {/if}
    {#if workoutSummary !== null}
      <p class="text-gray-500 text-lg sm:text-xl font-medium break-words">
        {workoutSummary}
      </p>
    {/if}
  </div>
  {#each exercisesAndRestsCollection?.items as exercise}
    {#if exercise.contentType === 'ExercisePanel'}
      <ExercisePanel
        panelContent={exercise.contentType}
        exerciseVideo={exercise?.exerciseVideo}
        title={exercise?.title}
        details={exercise?.details}
      ></ExercisePanel>
    {:else if exercise.contentType === 'RestPanel'}
      <RestPanel restDescription={exercise?.restDescription} duration={exercise?.duration}
      ></RestPanel>
    {/if}
  {/each}
</section>
